import { Geolocation, PermissionStatus } from '@capacitor/geolocation'
import logError from '../../consts/log-error'
import { platform } from '../device/platform'

let isGranted: boolean = false

function setGranted (data: PermissionStatus): void {
  isGranted = data.location === 'granted' || data.coarseLocation === 'granted'
}

async function checkPermissions (): Promise<void> {
  return await Geolocation.checkPermissions().then(async data => {
    setGranted(data)
    if (data.location.includes('prompt')) {
      if (platform === 'web') {
        // on web, the request permission appears when calling watchPosition or getPosition
        // and "requestPermissions" is not implemented on web
        isGranted = true
      } else {
        return await Geolocation.requestPermissions().then(setGranted)
      }
    }
  }).catch(logError)
}

export default async function verifyPermission (): Promise<void> {
  if (isGranted) {
    return await Promise.resolve()
  } else {
    return await checkPermissions().then(async () => {
      if (!isGranted) { await Promise.reject(new Error('Geolocation denied or unavailable')) }
    })
  }
}
